import { render, staticRenderFns } from "./AssistantAiMonitoring.vue?vue&type=template&id=f54ffbce&scoped=true"
import script from "./AssistantAiMonitoring.vue?vue&type=script&lang=js"
export * from "./AssistantAiMonitoring.vue?vue&type=script&lang=js"
import style0 from "./AssistantAiMonitoring.vue?vue&type=style&index=0&id=f54ffbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54ffbce",
  null
  
)

export default component.exports